import styled from 'styled-components';

const StartColumnsContainer = styled.div`
  display: flex;
`;

export default StartColumnsContainer;
